var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"suporte"},[_c('img',{attrs:{"src":require("@/assets/images/logo.png"),"alt":""}}),_c('h2',[_vm._v("Suporte eSUS Feedback")]),_c('div',{staticStyle:{"display":"none"},attrs:{"id":"info"}})])
}]

export { render, staticRenderFns }